<script>
  import service from '../../../../domain/arrematantes/services'
  import ProgressBar from '../../../_default/components/ProgressBar'

  export default {
    name: 'table-lotes',
    props: ['arrematante'],
    data () {
      return {
        isLoading: false,
        data: null,
        filterKey: '',
        sortKey: '',
        filtro: {
          tipo: 3
        },
        sortOrders: {
          'numero': 1,
          'titulo': 1,
          'comitente': 1,
          'arremate': 1
        },
        lotesChecked: [],
        actionCheckedLotes: ''
      }
    },
    computed: {
      filteredData: function () {
        let sortKey = this.sortKey
        let filterKey = this.filterKey && this.filterKey.toLowerCase()
        let order = this.sortOrders[sortKey] || 1
        let data = this.data
        // let tipo = this.filtro.tipo
        if (filterKey) {
          data = data.filter(function (row) {
            return Object.keys(row).some(function (key) {
              return String(row[key]).toLowerCase().indexOf(filterKey) > -1
            })
          })
        }
        if (sortKey) {
          data = data.slice().sort(function (a, b) {
            a = a[sortKey]
            b = b[sortKey]
            return (a === b ? 0 : a > b ? 1 : -1) * order
          })
        }
        return data
      },
      subTotalArremate () {
        let total = 0
        if (!this.data) {
          return 0
        }
        this.filteredData.forEach(function (lote) {
          total += Number(lote.valorArremate)
        })
        return total
      }
    },
    created () {
    },
    mounted () {
      this.load()
    },
    destroyed () {},
    methods: {
      load () {
        if (this.arrematante.apelido === 'PLATEIA') {
          return
        }
        this.isLoading = true
        this.$refs.pbar.start()
        service.getArrematanteLotes(this.arrematante.id)
          .then((response) => {
            this.isLoading = false
            this.$refs.pbar.finish()
            this.data = response.data
          })
          .catch((error) => {
            this.isLoading = false
            this.$refs.pbar.finish()
            alert('Não foi possível carregar os lotes')
            console.log(error)
          })
      },
      sortBy: function (key) {
        this.sortKey = key
        this.sortOrders[key] = this.sortOrders[key] * -1
      }
    },
    components: {ProgressBar}
  }
</script>

<template>
  <div>
    <progress-bar ref="pbar" pclass="progress2"></progress-bar>
    <table class="table-lotes-leilao table table-clicked table-striped bg-white b-a">
      <thead>
      <tr>
        <th class="text-nowrap" style="width: 60px" @click="sortBy('numero')"
            :class="{ active: sortKey === 'numero' }">
          LT <i class="fa" style="font-size: 10px"
                :class="sortOrders['numero'] > 0 ? 'fa-caret-down' : 'fa-caret-up'"></i>
        </th>
        <th class="hidden-print"></th>
        <th class="text-nowrap" @click="sortBy('titulo')" :class="{ active: sortKey === 'titulo' }">
          DESCRIÇÃO <i class="fa" style="font-size: 10px"
                       :class="sortOrders['titulo'] > 0 ? 'fa-caret-down' : 'fa-caret-up'"></i>
        </th>
        <th  class="text-nowrap" @click="sortBy('leilao')" :class="{ active: sortKey === 'leilao' }">
          LEILÃO <i class="fa" style="font-size: 10px"
                       :class="sortOrders['leilao'] > 0 ? 'fa-caret-down' : 'fa-caret-up'"></i>
        </th>
        <th class="text-nowrap" @click="sortBy('comitente')" :class="{ active: sortKey === 'comitente' }">
          COMITENTE <i class="fa" style="font-size: 10px"
                       :class="sortOrders['comitente'] > 0 ? 'fa-caret-down' : 'fa-caret-up'"></i>
        </th>
        <th class="text-nowrap" style="width: 120px" @click="sortBy('arremate')"
            :class="{ active: sortKey === 'arremate' }">ARREMATE <i class="fa" style="font-size: 10px"
                                                                    :class="sortOrders['arremate'] > 0 ? 'fa-caret-down' : 'fa-caret-up'"></i>
        </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="lote in filteredData">
        <td>{{ lote.numero }}</td>
        <td class="hidden-print"><img width="50" :src="lote.urlMin"></td>
        <td>
          <router-link target="_blank" :to="{name: 'lotes.visualizar', params: {leilao: lote.leilao, id: lote.id}}">
            {{lote.titulo.toUpperCase()}}
          </router-link>
        </td>
        <td>{{ lote.leilaoTitulo }}</td>
        <td>{{ lote.comitente ? lote.comitente : 'Sem comitente' }}</td>
        <td>R$ {{  lote.valorArremate | moeda }}</td>
      </tr>
      <tr>
        <td></td>
        <td class="hidden-print"></td>
        <td></td>
        <td></td>
        <td class="text-right"><strong>Total</strong></td>
        <td>R$ {{ subTotalArremate | moeda }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>



// WEBPACK FOOTER //
// TableLotes.vue?0c8bf588